import { NgModule, ModuleWithProviders } from '@angular/core';
import { FishRadio, FishActiveLabel, FishRadioGroup } from './radio';

export { FishRadio, FishActiveLabel, FishRadioGroup } from './radio';

const FISH_RADIO_DIRECTIVES = [FishRadio, FishActiveLabel, FishRadioGroup];


export class FishButtonsModule {
  static forRoot(): ModuleWithProviders { return { ngModule: FishButtonsModule, providers: [] }; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{ declarations: FISH_RADIO_DIRECTIVES, exports: FISH_RADIO_DIRECTIVES }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
